<template>
    <content-container>
        <div class="copyright">
            <p>Copyright © 2023 Plisko Vlad</p>
        </div>
    </content-container>
</template>

<script>
    export default {
        name: 'copy-right'
    }
</script>

<style scoped>
.copyright{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
}
</style>